import styled, { themeGet } from '@style'

const Container = styled.div`
  margin: 0 auto;
  padding: ${themeGet('space.4')};

  strong {
    color: ${themeGet('colors.saddleBrown')};
    font-weight: 700;
  }

  code {
    color: ${themeGet('colors.saddleBrown')};
    font-weight: 700;
    background-color: ${themeGet('colors.peach')};
    padding-left: ${themeGet('space.1')};
    padding-right: ${themeGet('space.1')};
    border-radius: 5px;
  }
`

export default Container
